import Layout from '@/layout'

const taskCenterRouter = {
  path: '/task-center',
  component: Layout,
  redirect: '/task-center/task-list',
  name: 'TaskCenter',
  meta: {
    title: 'taskCenter',
    icon: 'people'
  },
  children: [
    {
      path: 'task-list',
      component: () => import('@/views/task-center/task-list/index'),
      name: 'TaskList',
      meta: { title: 'taskList', noCache: false }
    },
    {
      path: 'store',
      component: () => import('@/views/task-center/store/index'),
      name: 'TaskStore',
      meta: { title: 'taskStore', noCache: false }
    },
    {
      path: 'integral-detail',
      component: () => import('@/views/task-center/integral-detail/index'),
      name: 'IntegralDetail',
      meta: { title: 'integralDetail', noCache: false }
    },
    {
      path: 'task-list/audit',
      component: () => import('@/views/task-center/task-list/audit/list.vue'),
      name: 'TaskAuditList',
      meta: { title: 'taskAuditList', noCache: false }
    },
    {
      path: 'withdraw',
      component: () => import('@/views/task-center/withdraw/index'),
      name: 'Withdraw',
      meta: { title: 'Withdraw', noCache: false }
    },
    {
      path: 'fission-invite',
      component: () => import('@/views/activity-manage/fission-invite/index'),
      name: 'FissionInvite',
      meta: { title: 'fissionInvite', noCache: false }
    },
    {
      path: 'api-list',
      component: () => import('@/views/task-center/api-list/index.vue'),
      name: 'apiList',
      meta: { title: 'apiList', noCache: false }
    },
    {
      path: 'integral-recharge',
      component: () => import('@/views/task-center/integral-recharge/index.vue'),
      name: 'IntegralRecharge',
      meta: { title: 'IntegralRecharge', noCache: false }
    },
    {
      path: 'sign-config',
      component: () => import('@/views/task-center/sign-config/index.vue'),
      name: 'SignConfig',
      meta: { title: 'signConfig', noCache: false }
    }
  ]
}

export default taskCenterRouter
